import { NgModule } from '@angular/core';
import { ErrorComponent } from './error.component';

@NgModule({
  declarations: [ErrorComponent]
})
export class ErrorModule {}
